//@ts-ignore
import Login from "@lib/components/Login";
import { RouteLocation, RouteRecordRaw } from "vue-router";
import icon from "../assets/icons/icon32x32.png";

const itemMode = (route: RouteLocation) => {
    if(route.params.mode == "edit") {
        if(route.params.id == "new")
            return ["Create"];        
        return ["Edit"];
    }
    if(route.params.id)
        return ["View"];

    return [];
};

const routes: RouteRecordRaw[] = [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: ["Login"],
            icon
        }
    },
    {
        path: '/map',
        name: 'map',
        component: () => import("src/views/Map.vue"),
        meta: {
            title: ["Map"],
            icon
        }
    },
    {
        path: "/admin",
        name: "live_admin",
        //@ts-ignore
        component: () => import("src/views/Admin"),
        children: [{
            meta: {
                collection: "users",
                title: (route: RouteLocation) => [
                    ...itemMode(route),
                    "Users", "Admin panel"
                ]
            },
            path: "users/:id?/:mode?",
            name: "live_admin_users",
            //@ts-ignore
            component: () => import("src/components/AdminPanel/User.vue"),
        }, {
            meta: {
                collection: "devices",
                title: (route: RouteLocation) => [
                    ...itemMode(route),
                    "Vessels", "Admin panel"
                ]
            },
            path: "devices/:id?/:mode?",
            name: "live_admin_devices",
            //@ts-ignore
            component: () => import("src/components/AdminPanel/Device"),
        }]
    },
        {
        path: "/survey/:page?",
        name: 'live_survey',
        meta: {
            title: ({
                meta: {tabTitles, startTab},
            }: RouteLocation & {
                meta: {tabTitles: {[key: string]: string}, startTab: string}
            }) =>
                tabTitles ?
                    [tabTitles.survey]
                    : [],
            icon
        },
        //@ts-ignore
        component: () => import("src/views/Index.vue"),
    },
    {
        path: "/:tab?/:groupTab?",
        name: 'live_index',
        meta: {
            title: ({
                meta: {tabTitles, startTab},
                params: {tab = startTab, groupTab}
            }: RouteLocation & {
                meta: {tabTitles: {[key: string]: string}, startTab: string}
            }) =>
                tabTitles && tab ?
                    [tabTitles[tab as string] || tabTitles[groupTab as string]]
                    : [],
            icon
        },
        //@ts-ignore
        component: () => import("src/views/Index.vue"),
    }
];

export default routes;
